$(document).on('click', '.tabs-nav li:not(.active)', function(e){
    e.preventDefault();
    $(this).siblings('li').removeClass('active');
    $(this).addClass('active');
    let tab = $(this).attr('data-tab');
    $('.tab-content[data-tab="'+ tab +'"]').siblings().removeClass('active');
    $('.tab-content[data-tab="'+ tab +'"]').addClass('active').hide().fadeIn();
})
